var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "p-3" },
        [
          _c("mvmSearch", {
            attrs: { show_all_mvm: false },
            on: { onSearch: _vm.onSearch },
          }),
          _c(
            "div",
            [
              _c(
                "el-form",
                { attrs: { inline: "" } },
                [
                  _c(
                    "el-form-item",
                    [
                      _vm.$route.meta.action.c
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  _vm.dialog = true
                                },
                              },
                            },
                            [_vm._v(" 新增 ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _vm.clients
                        ? _c("ExportExcel", {
                            attrs: {
                              "export-data": _vm.clients,
                              columns: _vm.columns,
                              filename: "客戶資料",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "responsive-table-shell mvm-list-table-shell" },
        [
          _c(
            "el-table",
            {
              staticClass: "nowrap-table mvm-list-table",
              attrs: {
                data: _vm.mvms,
                "row-class-name": _vm.statusClass,
                height: "85vh",
                size: "medium",
                fit: false,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "AssetNo",
                  label: "機台編號",
                  width: "110",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "locate.name",
                  label: "放置地址",
                  width: "240",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "model.name",
                  label: "型號",
                  width: "140",
                  sortable: "",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "client.name",
                  label: "客戶",
                  width: "180",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "user.name",
                  label: "巡補員",
                  width: "140",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("i", { staticClass: "el-icon-user-solid" }),
                        _vm._v(" " + _vm._s(scope.row.user.name) + " "),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "StockRatio",
                  label: "庫存比",
                  width: "100",
                  sortable: "",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "詳細資料", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              size: "small",
                              type: "primary",
                              round: "",
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.infoDialog = true
                                _vm.mvmId = scope.row.id
                              },
                            },
                          },
                          [_vm._v(" 點擊查看 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Status",
                  label: "狀態",
                  width: "120",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("statusTag", {
                          attrs: {
                            status: scope.row.Status,
                            "updated-at": scope.row.updated_at,
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "McDate",
                  label: "前次手動巡補",
                  width: "170",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("lastMcDate", {
                          attrs: { "updated-at": scope.row.McDate },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "IvmDate",
                  label: "前次自動巡補",
                  width: "170",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("lastMcDate", {
                          attrs: { "updated-at": scope.row.IvmDate },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LastConnectDate",
                  label: "連線時間",
                  width: "170",
                  sortable: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("lastUpdate", {
                          attrs: { "updated-at": scope.row.LastConnectDate },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "動作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.$route.meta.action.u
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onEditClick(scope.row)
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "el-icon-edit" }),
                                _vm._v("編輯"),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { width: "100%", title: "機台設定", visible: _vm.dialog },
          on: {
            "update:visible": function ($event) {
              _vm.dialog = $event
            },
            closed: function ($event) {
              _vm.mvmId = null
            },
          },
        },
        [
          _vm.dialog
            ? _c("updateForm", {
                attrs: {
                  id: _vm.mvmId,
                  "company-id": _vm.condition.company_id,
                  "client-id": _vm.condition.client_id,
                  "user-id": _vm.condition.user_id,
                },
                on: {
                  onSubmit: _vm.onSubmit,
                  onCancel: function ($event) {
                    _vm.dialog = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: { width: "100%", "lock-scroll": "", visible: _vm.infoDialog },
          on: {
            "update:visible": function ($event) {
              _vm.infoDialog = $event
            },
            closed: function ($event) {
              _vm.mvmId = null
            },
          },
        },
        [
          _vm.infoDialog
            ? _c("mvminfo", { attrs: { id: _vm.mvmId } })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }